import { render } from "./sections-headers-list.vue?vue&type=template&id=f45ae41e"
import script from "./sections-headers-list.vue?vue&type=script&lang=js"
export * from "./sections-headers-list.vue?vue&type=script&lang=js"

import "./sections-headers-list.vue?vue&type=style&index=0&id=f45ae41e&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__